//#region src/i18n/direction.ts
const RTL_SCRIPTS = /* @__PURE__ */ new Set([
	"Adlm",
	"Arab",
	"Hebr",
	"Mand",
	"Mend",
	"Nkoo",
	"Rohg",
	"Samr",
	"Syrc",
	"Thaa",
	"Yezi"
]);
/** Resolve the writing direction of a BCP 47 locale. */
function getTextDirection(locale) {
	try {
		const script = new Intl.Locale(locale).maximize().script;
		return script && RTL_SCRIPTS.has(script) ? "rtl" : "ltr";
	} catch {
		return "ltr";
	}
}
//#endregion
export { getTextDirection };

//# sourceMappingURL=direction.js.map